export default (params) => ({
  trigger: {
    name: 'configurator.add_item_to_bundle',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      item_id: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'configurator',
          'configurator_overlay',
        ],
      },
    },
    event: {
      name: 'add_item',
      params: {
        list: null,
      },
    },
  },
});
